export default __webpack_public_path__ + "static/media/campton-medium.2a00db65.ttf";